<template>
    <div id="tab-meal" :class="['tab-pane fade', {'active in': !editable }]">
        <meals-evaluation
            v-if="mealsEvaluation && weekDate"
            :week-date="weekDate"
            :meals-evaluation="mealsEvaluation"
            :patient-programme-start="patientProgrammeStart"
            :patient-current-month="patient.current_month"
            @weekChange="changeWeek"
        ></meals-evaluation>

        <meals-week-datepicker
            :meals-dates="mealsDates"
            :meals-notifications="mealsNotifications"
            :patient-programme-start="patientProgrammeStart"
            :week-start="weekDate"
            @weekChange="changeWeek"
        ></meals-week-datepicker>

        <section v-if="mealsEvaluation && meals" class="meals-wrapper" id="meals-index">
            <div v-if="loading" slot="spinner" class="loader-wrapper">
                <img :src="'../imgs/vitadio-loader.svg'" alt="">
            </div>

            <meals-week-list 
                v-else
                v-for="index in 7"
                :key="index"
                :week-start="weekDate"
                :coach-user="coachUser"
                :meals="meals"
                :meals-evaluation="mealsEvaluation"
                :editable="editable"
            ></meals-week-list>
        </section>
    </div>
</template>
<script>
    import MealsEvaluation from '@components/Meals/MealsEvaluation'
    import MealsWeekDatepicker from '@components/Meals/MealsWeekDatepicker'
    import MealsWeekList from '@components/Meals/MealsWeekList'

    export default {
        components: {
            MealsEvaluation,
            MealsWeekDatepicker,
            MealsWeekList
        },
        props: {
            editable: {
                type: Boolean,
                default: false
            },
            patient: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                weekDate: moment().startOf('isoWeek').format("YYYY-MM-DD"),
                mealsEvaluation: null,
                mealsDates: null,
                mealsNotifications: null,
                coachUser: null,
                meals: null,
                loading: true,
                patientProgrammeStart: moment(this.patient.programme_start).format("YYYY-MM-DD HH:mm:ss")
            }
        },
        updated: function () {
            this.$nextTick(function () {
                if(!this.loading) {
                    this.initSlider()
                }
            })
        },
        mounted() {
            this.fetch()
            this.fetchMeals()

            $('#patient-meal-detail').on('shown.bs.modal', function (e) {
                $(".page-user").addClass("modal-overflow");
            })

            $('#patient-meal-detail').on('hidden.bs.modal', function (e) {
                $(".page-user").removeClass("modal-overflow");
            })

            $(window).scroll(function() {
                var scrolled = $(document).scrollTop();

                if($(".tab-meal").hasClass("active")) {
                    if (scrolled > 460) {
                        $(".meals-evaluation-wrapper").addClass("fixed");
                    } else {
                        $(".meals-evaluation-wrapper").removeClass("fixed");
                    }
                }
            });

            let uri = new URI(location.href)

            var markAsSeen = false;
            $('[href="#tab-meal"]').on('click', function () {
                if (markAsSeen) return;
                markAsSeen = true
                axios.get(uri.origin() + uri.path() + '/meals/mark_as_seen?date=' + moment(this.weekDate).format('YYYY-MM-DD'))
            });
        },
        methods: {
            fetch() {
                //${this.patientId}
                axios.get(`/patients/${this.patient.id}/mealPlan`)
                    .then((res) => {
                        this.mealsEvaluation = res.data.data.patient_meal_evaluation
                        this.mealsDates = res.data.data.meal_dates
                        this.mealsNotifications = res.data.data.notifications
                        this.coachUser = res.data.data.coach ? res.data.data.coach.user : {}
                    })
                    .catch((e) => {
                        console.log(e)
                    })
            },
            fetchMeals() {
                axios.get(`/patients/${this.patient.id}/meals?date=${this.weekDate}`)
                    .then((res) => {
                        this.meals = res.data.data
                        this.loading = false
                    })
                    .catch((e) => {
                        console.log(e)
                    })
            },
            changeWeek(date) {
                this.loading = true
                
                $('.meals-list.slick-initialized').slick('unslick')

                let newDate = moment(date).startOf('isoWeek').format('YYYY-MM-DD')
                this.weekDate = newDate

                this.fetchMeals()
            },
            initSlider() {
                $('.meals-list').not('.slick-initialized').slick({
                    centerMode: false,
                    arrows: true,
                    variableWidth: true,
                    dots: false,
                    slidesToShow: 4,
                    initialSlide: 0,
                    infinite: false,
                    focusOnSelect: true,
                    nextArrow: '<button class="slick-next"><svg aria-hidden="true" height="20px" width="10px" focusable="false" data-prefix="fas" data-icon="angle-right" class="svg-inline--fa fa-angle-right fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="#fff" d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg></button>',
                    prevArrow: '<button class="slick-prev"><svg aria-hidden="true" height="20px" width="10px" focusable="false" data-prefix="fas" data-icon="angle-left" class="svg-inline--fa fa-angle-left fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="#fff" d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path></svg></svg></button>',
                    responsive: [
                    {
                        breakpoint: 1500,
                        settings: {
                        slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1370,
                        settings: {
                        slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                        slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                        slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: "unslick"
                    }
                    ]
                });
            }
        }
    }
</script>
